import { useWidgetData } from "../Contexts/dashboardHooks";
import { WidgetInfoButton } from "../Info/WidgetInfoButton";
import { PlayerCardView } from "./PlayerCardView";

/** Grid widget: renders the fetched PlayerCardData via the shared PlayerCardView. */
export function PlayerCardWidget({ id }: { id: string }) {
  const data = useWidgetData(id);
  const cardData = data?.type === "player_card" ? data.data : null;
  // The card has no header row, so the info/badge cluster floats in the top corner —
  // the spot every other widget's header puts it. It renders nothing when the card
  // has no info handler and follows no slicer.
  return (
    <div className="player-card-widget-frame">
      <span className="widget-floating-info">
        <WidgetInfoButton id={id} />
      </span>
      <PlayerCardView data={cardData ?? {}} />
    </div>
  );
}
